/* ===========================
   VHUES - Cart Free Shipping Messaging
   Updates every .vhues-cart-rewards element safely
   No global dedupe or element removal
   =========================== */

(function () {
  const TARGET_SELECTOR = '.vhues-cart-rewards';

  /*
    Adjust these only if your Shopify free shipping thresholds change.
    CAD and USD are included because VHUES primarily sells to Canada and the U.S.
    Other currencies receive a neutral message to avoid inaccurate threshold claims.
  */
  const FREE_SHIP_THRESHOLDS = {
    CAD: 70,
    USD: 70
  };

  function getCurrency(cart) {
    return (
      cart?.currency ||
      window.Shopify?.currency?.active ||
      document.documentElement.getAttribute('data-currency') ||
      'CAD'
    ).toUpperCase();
  }

  function formatMoney(amount, currency) {
    const value = Math.max(0, Number(amount) || 0);

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return `$${value.toFixed(2)}`;
    }
  }

  function buildHtml(cart) {
    const currency = getCurrency(cart);
    const total = (cart.total_price || 0) / 100;
    const threshold = FREE_SHIP_THRESHOLDS[currency];

    if (!threshold) {
      return `<span class="vhues-reward-single vhues-reward-neutral">Shipping options shown at checkout</span>`;
    }

    if (total < threshold) {
      const remaining = threshold - total;
      return `<span class="vhues-reward-single">Add <strong>${formatMoney(remaining, currency)}</strong> for free shipping</span>`;
    }

    return `<span class="vhues-reward-single vhues-reward-unlocked">Free shipping unlocked</span>`;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function applyStateClasses(el, html) {
    el.classList.remove('vhues-rewards-unlocked', 'vhues-rewards-close');

    if (html.includes('Free shipping unlocked')) {
      el.classList.add('vhues-rewards-unlocked');
      return;
    }

    const match = html.match(/Add <strong>.*?([0-9]+(?:\.[0-9]{2})?)<\/strong>/);
    if (match) {
      const numeric = Number(match[1]);
      if (!Number.isNaN(numeric) && numeric > 0 && numeric <= 15) {
        el.classList.add('vhues-rewards-close');
      }
    }
  }

  async function vhuesUpdateCartRewards() {
    const els = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
    if (!els.length) return;

    try {
      const cart = await getCart();
      const html = buildHtml(cart);

      els.forEach((el) => {
        if (!el || !(el instanceof HTMLElement)) return;
        if (el.innerHTML !== html) el.innerHTML = html;
        applyStateClasses(el, html);
      });
    } catch (err) {
      console.error('VHUES cart reward update failed:', err);
    }
  }

  window.vhuesUpdateCartRewards = vhuesUpdateCartRewards;

  let timer;
  function debouncedUpdate() {
    clearTimeout(timer);
    timer = setTimeout(vhuesUpdateCartRewards, 150);
  }

  function updateWithRetry(maxTries = 16) {
    let tries = 0;

    const tick = () => {
      tries += 1;

      if (document.querySelector(TARGET_SELECTOR)) {
        vhuesUpdateCartRewards();
        return;
      }

      if (tries < maxTries) {
        setTimeout(tick, 120);
      }
    };

    tick();
  }

  function observeCartRegions() {
    const roots = [
      document.querySelector('cart-drawer-component'),
      document.querySelector('cart-items-component'),
      document.querySelector('.cart-drawer__dialog'),
      document.querySelector('.cart-drawer__summary'),
      document.querySelector('form[action="/cart"]')
    ].filter(Boolean);

    if (!roots.length) return;

    const observer = new MutationObserver(() => debouncedUpdate());

    roots.forEach((root) => {
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateWithRetry());
  } else {
    updateWithRetry();
  }

  window.addEventListener('load', () => {
    observeCartRegions();
    updateWithRetry();
  });

  document.addEventListener('theme:cart:change', debouncedUpdate);
  document.addEventListener('cart:updated', debouncedUpdate);
  document.addEventListener('cart:change', debouncedUpdate);
  document.addEventListener('ajaxCart:afterCartLoad', debouncedUpdate);
  document.addEventListener('ajaxCart:afterUpdate', debouncedUpdate);
  document.addEventListener('cart-drawer:open', () => updateWithRetry());
})();